import {
  BrandTile,
  IBrandTileProps,
} from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/BrandTile";
import { ILeanBrandTileAdapter } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { SignUpElement } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { useQuery_escape_hatch as useBulkFetchBrandsQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/bulk-brand-tiles/post-hooks";
import { Grid, IGridProps } from "@faire/web/slate/Layout/Grid";
import React from "react";

import { deduplicateProductsOrBrands } from "./utils";

// TODO: Event Tracking
export interface IBrandInput
  extends Pick<
    IBrandTileProps,
    "type" | "withoutFavourite" | "showMinimum" | "impressionProviderProps"
  > {
  token: string;
}

interface IProps extends Omit<IGridProps, "children" | "columnTemplate"> {
  brands: IBrandInput[];
}

export const BuilderRetailerBrandTileSection: React.FC<IProps> = ({
  brands,
  ...gridProps
}) => {
  const deduplicatedBrands = deduplicateProductsOrBrands(brands);

  const { data, isPending } = useBulkFetchBrandsQuery({
    brand_tokens: deduplicatedBrands.map((brand) => brand.token),
  });

  if (isPending || !data) {
    return null;
  }

  const { brand_tiles } = data;

  return (
    <Grid {...gridProps} className="w-full">
      {brand_tiles?.map((brandTile, index) => (
        <BrandTile
          key={brandTile.token}
          signUpTracking={{
            element: SignUpElement.PRODUCT_GRID,
            sourceId: "builder-io-retailer-brand-tile",
          }}
          type={brands[index]?.type ?? "common"}
          brandTile={ILeanBrandTileAdapter.fromIBrandTile(brandTile)}
          withoutFavourite={brands[index]?.withoutFavourite}
          showMinimum={brands[index]?.showMinimum}
        />
      ))}
    </Grid>
  );
};
